import {Component, EventEmitter, Input, Output} from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import * as faIcons from '@fortawesome/free-solid-svg-icons';
import {ActivatedRoute, Router} from "@angular/router";
import {Store} from "@ngrx/store";
import {interfaceActions} from "../../state/interface/interface.actions";
import {NgIf} from "@angular/common";

@Component({
  selector: 'pane-back-button',
  standalone: true,
  imports: [
    FontAwesomeModule,
    NgIf
  ],
  templateUrl: './pane-back-button.component.html',
  styleUrl: './pane-back-button.component.scss'
})
export class PaneBackButtonComponent {

  protected readonly faIcons = faIcons;
  @Input() backToPrimary?: string | null
  @Input() backToLeftPane?: string | null
  @Input() backToRightPane: string | null
  @Input() backToPopUpTopRight: string | null
  @Input() backToPopUpTopLeft: string | null
  @Input() backToPane: string | null
  @Input() backToNewModalPane: string | null
  @Input() text?: string | null = "back"
  @Input() buttonFacingRight?: boolean = false
  @Output() onClose?: EventEmitter<void> = new EventEmitter<void>()

  constructor(
      private router: Router,
      private route: ActivatedRoute,
      private store: Store
  ) { }
  back() {
    if (this.backToPrimary !== undefined) {
      this.router.navigate([this.backToPrimary]);
      return
    }
    if (this.backToLeftPane !== undefined) {
      this.router.navigate([{outlets: {'left-pane': this.backToLeftPane || null}}])
      return
    }
    if (this.backToRightPane !== undefined) {
      this.router.navigate([{outlets: {'right-pane': this.backToRightPane || null}}])
      return
    }
    if (this.backToNewModalPane !== undefined) {
      this.router.navigate([{outlets: {'new-modal-pane': this.backToNewModalPane || null}}])
      return
    }
    this.router.navigate(['..'], { relativeTo: this.route });
    this.onClose.emit()
  }
}
